<template>
  <div class="main-wrapper">
    <div class="main-scroll">
      <Navs></Navs>
      <home></home>
      <Foots class="foots"></Foots>
    </div>
    
    <bottom-backtop></bottom-backtop>

  </div>
</template>
<script>
import Navs from '../common/navs'
import Foots from '../common/foots'
import home from './campus'
import BottomBacktop from '../common/BottomBacktop';

export default {
  components: {
    Navs,
    Foots,
    home,
    BottomBacktop
  },
  name: 'Home',
  data() {
    return {}
  },
  mounted() {
  },
  methods: {}

}
</script>
<style lang="scss" scoped>

</style>
